import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "284bc2de-7b5f-4557-a200-b21b25475ece",
    content: "Running convolution describes the convolution with an continuous input audio stream.",
    options: {},
  },
  {
    id: "8794a924-4807-4ff8-89cc-361667b47333",
    content: "The longer the block length the lower the latency.",
    options: {},
  },
  {
    id: "c0dbdd5f-9af5-4a3d-9da5-23063a47c5f2",
    content: "The longer the block length the higher the latency.",
    options: {},
  },
  {
    id: "1857ef14-6d1d-43c8-9386-85db1a25c470",
    content: "The length of a convolved audio is L + B if the input audio has L samples and the filter has B samples.",
    options: {},
  },
];

export const task: Task = {
  id: "8154ad00-9540-4c67-a144-ef63d0a4e344",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["284bc2de-7b5f-4557-a200-b21b25475ece", "8794a924-4807-4ff8-89cc-361667b47333"],
};
